/*
 * Copyright (c) 2024-2025.
 * The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 *
 */

import Dates from 'utils/Dates'
import { Package } from 'types/entities/Package'
import { useTranslation } from 'react-i18next'
import { PackageCategory } from 'types/enums/PackageCategory'
import { Reservation } from 'types/entities/Reservation'

export const getMinMaxHourOfWeek = (
    reservations: Reservation[]
): { min: number; max: number } => {
    if (!reservations || reservations.length === 0) return { min: 8, max: 22 }
    let min = 24
    let max = 0
    reservations.forEach((r) => {
        const hour = r.hour
        if (hour < min) min = hour
        if (hour > max) max = hour
    })
    return { min: Math.max(0, min - 1), max: Math.min(24, max + 1) }
}

export const getTimeslotsRange = (start: number, end: number): number[] => {
    const range: number[] = []
    for (let i = start; i <= end; i++) {
        range.push(i)
    }
    return range
}

export const getReservationCountByHour = (
    hour: number,
    counts: { [key: number]: number }
): number => {
    return counts ? counts[hour] || 0 : 0
}

export const getMaxReservationsCountByHourFromReservations = (
    timeslotsRange: number[],
    reservations: Reservation[]
): { [key: number]: number } => {
    const maxCounts: { [key: number]: number } = {}
    if (!reservations) return maxCounts

    timeslotsRange.forEach((hour) => {
        const countsPerDay: { [key: string]: number } = {}
        reservations.forEach((r) => {
            if (r.hour === hour) {
                const day = Dates.ymd(r.date)
                countsPerDay[day] = (countsPerDay[day] || 0) + 1
            }
        })
        const maxForThisHour =
            Object.values(countsPerDay).length > 0
                ? Math.max(...Object.values(countsPerDay))
                : 0
        maxCounts[hour] = maxForThisHour
    })

    return maxCounts
}

export const moduloMinutesForFakeTimeslots = (timeslot: any) => {
    return (
        Dates.hour(timeslot.start_at) +
        ':' +
        (Dates.minute(timeslot.start_at) >= 30 ? '30' : '00')
    )
}

export const useGetRaceNamesByTimeslotsAndPackage = (
    index: number,
    Package: Package | null
) => {
    const { t } = useTranslation()

    if (Package && Package.category === PackageCategory.Event) {
        return t('Reservation time')
    }

    // switch (index) {
    //     case 0:
    //         return t("First heat");
    //     case 1:
    //         return t("Second heat");
    //     case 2:
    //         return t("Third heat");
    //     case 3:
    //         return t("Fourth heat");
    //     case 4:
    //         return t("Fifth heat");
    //     default:
    //         return t("Reservation time");
    // }

    switch (index) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            return t('Race')
        default:
            return t('Reservation time')
    }
}

export const useGetAccessNamesByTimeslotsAndPackage = (
    index: number,
    Package: Package | null
) => {
    const { t } = useTranslation()

    if (Package && Package.category === PackageCategory.Event) {
        return t('Reservation time')
    }

    switch (index) {
        case 0:
            return t('Start')
        default:
            return t('End')
    }
}
